var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgI2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.00001 13.2059L1.01501 10.9049L6.00001 8.76892V13.2059Z",
    fill: "#3EA138"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.985 10.9059L22 13.2059V8.76892L26.985 10.9059Z",
    fill: "#3EA138"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28 12.64V24C28 25.654 26.654 27 25 27H3C1.346 27 0 25.654 0 24V12.64L13.581 18.908C13.847 19.03 14.153 19.03 14.419 18.908L28 12.64Z",
    fill: "#3EA138"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20 14.129V1H8V14.129L14 16.898L20 14.129ZM12 13C11.448 13 11 12.552 11 12C11 11.448 11.448 11 12 11H15V10H12C11.448 10 11 9.552 11 9V6C11 5.448 11.448 5 12 5H13V4H15V5H16C16.552 5 17 5.448 17 6C17 6.552 16.552 7 16 7H13V8H16C16.552 8 17 8.448 17 9V12C17 12.552 16.552 13 16 13H15V14H13V13H12Z",
    fill: "#3EA138"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgI2);
export default __webpack_public_path__ + "static/media/i2.e324485f6f431909d5e38ae4f12e3022.svg";
export { ForwardRef as ReactComponent };